<div a-style p=3 align=center>
    <!-- <img a-style mb="2" src="" h="30"> -->
    <m-image a-style src="https://new-api.mesbro.com/uploads/99/99/99/99/99/95/74.svg" mb="2" h="30"></m-image>
    <m-text [type]="gs.enums.texts.paragraph41" text="Let's get Started" mb="1"></m-text>
    <m-button a-style [types]="gs.enums.buttons.button20" text="Checkout"></m-button>
</div> 